import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CentralClientePacoteDetalharComponent } from './central-cliente-pacote-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: CentralClientePacoteDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class CentralClientePacoteDetalharRoutingModule { }
